import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/AppInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.1.5/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.1.5/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
